export const GET_HOLIDAYS = `
  query GetHolidays($includeInactive: Boolean) {
    holidays(includeInactive: $includeInactive) {
      id
      title
      eventDate
      recurring
      isActive
    }
  }
`;

export const CREATE_HOLIDAY = `
  mutation CreateHoliday($title: String!, $eventDate: String!) {
    createHoliday(title: $title, eventDate: $eventDate) {
      holiday {
        id
        title
        eventDate
        recurring
        isActive
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_HOLIDAY = `
  mutation UpdateHoliday($id: ID!, $title: String, $eventDate: String, $recurring: Boolean, $isActive: Boolean) {
    updateHoliday(id: $id, title: $title, eventDate: $eventDate, recurring: $recurring, isActive: $isActive) {
      holiday {
        id
        title
        eventDate
        recurring
        isActive
      }
      errors {
        property
        description
      }
    }
  }
`;
